( function ( $ ) {
	const $popup = $( '.otod-popup' );
	const $closeBtn = $popup.find( '.otod-popup__close-btn' );

	const closePopup = () => {
		$popup.fadeOut( 500, 'swing', function () {
			$popup.remove();
		} );
	};

	if ( $popup.hasClass( 'otod-popup--toast' ) ) {
		setTimeout( closePopup, 10000 );
	}

	$closeBtn.on( 'click', function ( e ) {
		e.preventDefault();
		closePopup();
	} );
} )( jQuery );
